import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "@infinitaslearning/pixel-design-system/styles";
import { StyledIcon } from "./StyledIcon.styled";
import { getIconBaseUrl } from "./iconBaseUrl";
export default function getIcon(baseName, version) {
    return ({ set, color, htmlColor, fontSize, sx, className, titleAccess, ...props }) => {
        const { pixel } = useTheme();
        const assetFolder = set ?? pixel?.icon?.set ?? "set1";
        const src = `${getIconBaseUrl()}/icons/v${version}/${assetFolder}/${baseName}.svg`;
        const computedClassName = [
            "PixelIcon",
            className ? className : "",
            "MuiSvgIcon-root",
            color ? "MuiSvgIcon-color" : "",
        ]
            .filter(Boolean)
            .join(" ");
        const dataPixel = `PixelIcon ${baseName}`;
        return (_jsx(StyledIcon, { className: computedClassName, "data-pixel": dataPixel, src: src, color: color, htmlColor: htmlColor, fontSize: fontSize, sx: sx, "aria-label": titleAccess || undefined, role: titleAccess ? "img" : undefined, ...props }));
    };
}
//# sourceMappingURL=getIcon.js.map